module.exports = __webpack_public_path__ + "static/media/logo03.9350190c.svg";